module.exports = __webpack_public_path__ + "media/images/brands/marque-manucurist@3x-b2cc6312863835a6174f146ad479bda4.jpg";